import React from 'react';
import Tabs from '../../../../components/Tabs';
import CouponDetailUsageHistoryList from '../CouponDetailUsageHistoryList';
import CouponDetailUnUsageHistoryList from '../CouponDetailUnUsageHistoryList';
import CouponInfo from '../../common/CouponInfo';
import CouponDetailProductItemList from '../CouponDetailProductItemList';
import CouponDetailBrandItemList from '../CouponDetailBrandItemList';
import { COUPON_AVAILABLE_TYPE } from '../../../../constants/service/app/couponConstants';
import './CouponDetailInfo.scss';

const CouponDetailInfo = (props) => {
  const {
    form,
    couponInfo,
    couponUsageHistory,
    couponUnUsageHistory,
    getCouponUsageHistoryList,
    getCouponUnUsageHistoryList,
    couponProductLink,
    mainProductCategorySelectList,
    subProductCategorySelectList,
    couponBrandLink,
    getCouponProductLinkList,
    getCouponBrandLinkList,
    toggleModal,
    getCouponUsageHistoryListExcelDownload,
    getCouponUnUsageHistoryListExcelDownload,
    getProductSubCategoryList,
  } = props;

  return (
    <div className="coupon-detail-info">
      {/* 주문 상세 */}
      <Tabs
        list={[
          {
            title: '쿠폰 정보',
            content: <CouponInfo form={form} isEditable={false} couponInfo={couponInfo} />,
          },
          {
            title: '사용 내역',
            content: (
              <CouponDetailUsageHistoryList
                couponUsageHistory={couponUsageHistory}
                getProductSubCategoryList={getProductSubCategoryList}
                getCouponUsageHistoryListExcelDownload={getCouponUsageHistoryListExcelDownload}
                getList={getCouponUsageHistoryList}
              />
            ),
          },
          {
            title: '미사용 내역',
            content: (
              <CouponDetailUnUsageHistoryList
                couponUnUsageHistory={couponUnUsageHistory.list}
                filterOption={couponUnUsageHistory.filterOption}
                pagination={couponUnUsageHistory.pagination}
                getCouponUnUsageHistoryListExcelDownload={getCouponUnUsageHistoryListExcelDownload}
                getList={getCouponUnUsageHistoryList}
              />
            ),
          },
          {
            title: '쿠폰 사용 가능한 상품',
            disabled: !(couponInfo.availableType === COUPON_AVAILABLE_TYPE.TARGET_PRODUCT_COUPON),
            content: (
              <CouponDetailProductItemList
                minimumPurchasePrice={couponInfo.minimumPurchasePrice}
                discountType={couponInfo.discountType}
                discountAmount={couponInfo.discountAmount}
                maxDiscountPrice={couponInfo.maxDiscountPrice}
                mainProductCategorySelectList={mainProductCategorySelectList}
                subProductCategorySelectList={subProductCategorySelectList}
                filterOption={couponProductLink.filterOption}
                pagination={couponProductLink.pagination}
                couponProductLinkList={couponProductLink.list}
                getList={getCouponProductLinkList}
                getProductSubCategoryList={getProductSubCategoryList}
              />
            ),
          },
          {
            title: '쿠폰 사용 가능한 브랜드',
            disabled: !(couponInfo.availableType === COUPON_AVAILABLE_TYPE.TARGET_BRAND_COUPON),
            content: (
              <CouponDetailBrandItemList
                couponInfo={couponInfo}
                toggleModal={toggleModal}
                filterOption={couponBrandLink.filterOption}
                pagination={couponBrandLink.pagination}
                couponBrandLinkList={couponBrandLink.list}
                getList={getCouponBrandLinkList}
              />
            ),
          },
        ]}
      />
    </div>
  );
};

export default CouponDetailInfo;
